import {
  REQUEST_STATEMENTS,
  REQUEST_STATEMENTS_SUCCESS,
  REQUEST_STATEMENTS_FAIL,
  REQUEST_RELOAD_STATEMENTS,
  REQUEST_RELOAD_STATEMENTS_SUCCESS,
  REQUEST_RELOAD_STATEMENTS_FAIL,
  REQUEST_STATEMENTS_ITEM,
  REQUEST_STATEMENTS_ITEM_SUCCESS,
  REQUEST_STATEMENTS_ITEM_FAIL,
  CLEAR_STATEMENTS_ERROR
} from "./actionTypes";

import { getStatementsUrl, statementItemUrl } from "../../config/apiConfig";
import { parseFetchOptions } from "../user/actions";
import errors from "../../utils/errors";

// Data
const requestStatements = payload => ({
  type: REQUEST_STATEMENTS,
  payload
});

const requestStatementsSuccess = payload => ({
  type: REQUEST_STATEMENTS_SUCCESS,
  payload
});

const requestStatementsFail = payload => ({
  type: REQUEST_STATEMENTS_FAIL,
  payload
});

export const getStatements =
  ({ caseId, onFail, requestSource }) =>
  async dispatch => {
    dispatch(requestStatements(caseId));

    const statementsUrl = getStatementsUrl(caseId);
    const params = new URLSearchParams();

    if (requestSource) params.set("requestSource", requestSource);

    const url = params.toString()
      ? `${statementsUrl}?${params}`
      : statementsUrl;

    dispatch(
      parseFetchOptions(async options => {
        const response = await fetch(url, {
          method: "GET",
          headers: options.headers
        }).catch(error => {
          if (onFail) onFail();
          dispatch(requestStatementsFail(error));
        });

        if (response && response.ok) {
          const data = await response.json();
          dispatch(requestStatementsSuccess(data));
        } else {
          dispatch(requestStatementsFail(errors.responseError(response)));
          if (onFail) onFail();
        }
      })
    );
  };

// Data
const requestReloadStatements = payload => ({
  type: REQUEST_RELOAD_STATEMENTS,
  payload
});

const requestReloadStatementsSuccess = payload => ({
  type: REQUEST_RELOAD_STATEMENTS_SUCCESS,
  payload
});

const requestReloadStatementsFail = payload => ({
  type: REQUEST_RELOAD_STATEMENTS_FAIL,
  payload
});

export const reloadMedia =
  ({ caseId, onFail }) =>
  async (dispatch, getState) => {
    const { isReloading } = getState().statements;

    if (isReloading) return;

    dispatch(requestReloadStatements(caseId));

    dispatch(
      parseFetchOptions(async options => {
        const response = await fetch(getStatementsUrl(caseId), {
          method: "GET",
          headers: options.headers
        }).catch(error => {
          if (onFail) onFail();
          dispatch(requestReloadStatementsFail(error));
        });

        if (response && response.ok) {
          const data = await response.json();
          dispatch(requestReloadStatementsSuccess(data));
        } else {
          dispatch(requestReloadStatementsFail(errors.responseError(response)));
          if (onFail) onFail();
        }
      })
    );
  };

// Get Media Item
const requestStatementsItem = () => ({
  type: REQUEST_STATEMENTS_ITEM
});

const requestStatementsItemSuccess = payload => ({
  type: REQUEST_STATEMENTS_ITEM_SUCCESS,
  payload
});

const requestStatementsItemFail = payload => ({
  type: REQUEST_STATEMENTS_ITEM_FAIL,
  payload
});

export const getMediaItem =
  ({ caseId, mediaId, onFail }) =>
  async dispatch => {
    dispatch(requestStatementsItem());

    dispatch(
      parseFetchOptions(async options => {
        const response = await fetch(statementItemUrl(caseId, mediaId), {
          method: "GET",
          headers: options.headers
        }).catch(error => {
          if (onFail) onFail();
          dispatch(requestStatementsItemFail(error));
        });

        if (response && response.ok) {
          const data = await response.json();
          dispatch(requestStatementsItemSuccess(data));
        } else {
          if (onFail) onFail();
          dispatch(requestStatementsItemFail(errors.responseError(response)));
        }
      })
    );
  };

// Clear Error
export const clearMediaError = () => dispatch => {
  dispatch({
    type: CLEAR_STATEMENTS_ERROR
  });
};
